/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {dlsColor} from '../../theme/theme';
import {DLSTheme} from '../../types/types';

export interface SeperatorProps {
  seperator: string;
  className?: string;
};

const useStyle = makeStyles((theme: DLSTheme) => ({
  root : {
    color : dlsColor('grey3')
  }
}));

export const Seperator = ({
  seperator,
  className
}: SeperatorProps) => {
  const classes = useStyle();
  return (
    <span className={className || classes.root}>
      {seperator}
    </span>
  );
};

export default Seperator;
